<template>
    <div class="my-panel-task-list">
        <div v-if="type === 'future'" class="my-panel-task-header">
            <h2>{{ __('Future events') }}</h2>
        </div>

        <div v-if="tasks" class="table-layout table-patient events-list">
            <div class="table-head">
                <div class="table-tr">
                    <div class="table-th task-title">{{ __('Event') }}</div>
                    <div class="table-th task-patient">{{ __('Patient') }}</div>
                    <div class="table-th task-date"></div>
                </div>
            </div>

            <div class="table-body">
                <my-panel-task-row
                    v-for="(task, index) in tasks"
                    v-if="isTaskVisible(index)"
                    :key="index"
                    :task="task"
                    :coach="coach"
                    :isToday="type !== 'future' ? true : false"
                ></my-panel-task-row>
            </div>
        </div>

        <template v-else>
            <figure class="my-panel-task-no-patients--img">
                <span class="material-icons-round">event_busy</span>
            </figure>
            <p v-if="type !== 'future'" class="my-panel-task-no-patients--text">{{ __('You have no events for today') }}</p>
            <p v-else class="my-panel-task-no-patients--text">{{ __("No future events") }}</p>
        </template>

        <v-button 
            v-if="type === 'future' && tasks && tasks.length > 5" 
            :label="__(showAllBtnTitle)+' ('+hiddenTasksNum+')'" 
            variant="secondary" 
            size="sm" 
            position="center" 
            @onClick="toggleAll()"
        ></v-button>
    </div>
</template>

<script>
import MyPanelTaskRow from './MyPanelTaskRow.vue'
export default {
    components: {
        MyPanelTaskRow
    },
    props: {
        tasks: {
            type: Array | Object,
            required: true
        },
        coach: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            hidden: true
        }
    },
    computed: {
        showAllBtnTitle() {
            return this.hidden ? 'View all' : 'Hide'
        },
        hiddenTasksNum() {
            return this.tasks.length - 5
        }
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        isTaskVisible(index) {
            if(this.type === 'future') {
                if(index < 5 || !this.hidden) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        toggleAll() {
            this.hidden = !this.hidden
        }
    }
}
</script>
